/**
 * SSR-safe localStorage wrapper. Use this everywhere instead of touching
 * `window.localStorage` directly so consumers don't have to scatter
 * `typeof window !== 'undefined'` guards across the codebase.
 *
 * Convention: storage keys follow the `discovr-<app>-<feature>` kebab pattern
 * (e.g. `discovr-brand-campaign-drafts`). Avoid mixing snake/camel/kebab.
 */
const isBrowser = (): boolean => typeof window !== 'undefined';

export const storage = {
  get(key: string): string | null {
    return isBrowser() ? window.localStorage.getItem(key) : null;
  },
  set(key: string, value: string): void {
    if (isBrowser()) window.localStorage.setItem(key, value);
  },
  remove(key: string): void {
    if (isBrowser()) window.localStorage.removeItem(key);
  },
};
